<template>
  <div class="backdrop">
    <div class="backdrop-top">
      <div class="title-box">
        <img src="../../../assets/images/return.png" @click="$router.go(-1)"><span>资产盘点详情</span>
      </div>
      <div class="list-wrapper">
        <div class="list-detail">
          <div class="detail-box">
            <div class="title">{{detail.goods_name}}</div>
            <div class="describe"><label>资产编码</label>{{detail.asset_num}}</div>
            <div class="describe"><label>状态</label>{{detail.old_status_info}}</div>
            <div class="describe"><label>使用人</label>{{detail.old_keeper_member_name}}</div>
            <div class="describe"><label>存放位置</label>{{detail.old_area_name}}</div>
          </div>
        </div>
        <div class="row-item" style="margin-top: 8px">
          <label style="flex: 1;font-weight: 600;">盘点信息</label>
          <div v-if="detail.stocktake_status == 0">未盘</div>
          <div v-if="detail.stocktake_status == 1">{{detail.stocktake_member_name}} | 盘平</div>
          <div v-if="detail.stocktake_status == 2">{{detail.stocktake_member_name}} | 盘盈</div>
          <div v-if="detail.stocktake_status == 3">{{detail.stocktake_member_name}} | 盘亏</div>
        </div>
        <div class="row-item" v-if="detail.stocktake_status == 3">
          <label>状态</label>
          <div style="flex: 1;text-align: right;color: gray;">{{detail.new_status_info}}</div>
        </div>
        <div class="row-item" v-else @click="stateClick">
          <label>状态</label>
          <input type="text" v-model="detail.new_status_info" placeholder="请选择状态" readonly>
          <img src="../../../assets/images/right_jt.png">
        </div>
        <div class="row-item" v-if="detail.stocktake_status == 3">
          <label>使用人</label>
          <div style="flex: 1;text-align: right;color: gray;">{{detail.new_keeper_member_name}}</div>
        </div>
        <div class="row-item" v-else @click="userClick">
          <label>使用人</label>
          <input type="text" v-model="detail.new_keeper_member_name" placeholder="请选择使用人" readonly>
          <img src="../../../assets/images/right_jt.png">
        </div>
        <div class="row-item" v-if="detail.stocktake_status == 3">
          <label>存放位置</label>
          <div style="flex: 1;text-align: right;color: gray;">{{detail.new_area_name}}</div>
        </div>
        <div class="row-item" v-else @click="areaClick">
          <label>存放位置</label>
          <input type="text" v-model="detail.new_area_name" placeholder="请选择存放位置" readonly>
          <img src="../../../assets/images/right_jt.png">
        </div>
        <div class="row-item">
          <label>盘点备注</label>
          <input type="text" v-model="detail.remark" placeholder="请输入盘点备注" >
        </div>
      </div>
    </div>
    <div class="footer-wrapper" v-if="show_stocktake_btn == 1 && detail.stocktake_status == 0">
      <button class="delete-btn" @click="save(3)">盘亏</button>
      <button class="preserve-btn" @click="save(1)">保存盘点</button>
    </div>
    <div class="footer-wrapper" v-if="show_stocktake_btn == 1 && detail.stocktake_status == 1">
      <button class="delete-btn" @click="save(0)">撤销盘点</button>
      <button class="preserve-btn" @click="save(1)">保存盘点</button>
    </div>
    <div class="footer-wrapper" v-if="show_stocktake_btn == 1 && detail.stocktake_status == 2">
      <button class="delete-btn" @click="del()">删除盘盈</button>
      <button class="preserve-btn" @click="save(2)">保存盘盈</button>
    </div>
    <div class="footer-wrapper" v-if="show_stocktake_btn == 1 && detail.stocktake_status == 3">
      <button class="delete-btn" @click="save(0)">撤销盘亏</button>
      <button class="preserve-btn" @click="save(3)">保存盘亏</button>
    </div>

    <!-- 选择状态 -->
    <div class="select-mask" v-if="statePopup">
      <div class="select-mask-blank" @click="clickBlank"></div>
      <div class="select-mask-inner">
        <div class="select-mask-content">
          <div class="head-mask">选择状态<img class="close-mask" @click="stateClose" src="../../../assets/images/close.png"></div>
          <el-tree :data="stateData" :props="defaultProps" @node-click="selectStatus"></el-tree>
        </div>
      </div>
    </div>

    <!-- 存放位置 -->
    <div class="select-mask" v-if="areaPopup">
      <div class="select-mask-blank" @click="clickBlank"></div>
      <div class="select-mask-inner">
        <div class="select-mask-content">
          <div class="head-mask">选择存放位置<img class="close-mask" @click="areaClose" src="../../../assets/images/close.png"></div>
          <el-tree :data="areaData" :props="defaultProps" @node-click="selectArea"></el-tree>
        </div>
      </div>
    </div>

    <!-- 选择使用人 -->
    <div class="select-mask" v-if="userPopup">
      <div class="select-mask-blank" @click="clickBlank"></div>
      <div class="select-mask-inner">
        <div class="select-mask-content">
          <div class="head-mask">选择使用人<img class="close-mask" @click="userClose" src="../../../assets/images/close.png"></div>
          <div class="search-box" style="padding: 15px 0">
            <input type="text" v-model="userKeywords" placeholder="请输入姓名/手机号" @keyup.enter="findUser" @input="findUser">
          </div>
          <el-tree :data="userData" :props="defaultProps" @node-click="selectKeeper"></el-tree>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'AssetStocktakingDetail',
  metaInfo: {
    title: '资产盘点'
  },
  data () {
    return {
      stocktaking_id: 0,
      show_stocktake_btn: 0,
      detail: {},
      before_page_name: '', // 前页名称，用于跳回判断
      areaPopup: false, // 存放位置
      areaData: [],
      userPopup: false, // 使用人
      userData: [],
      allUserData: [],
      userKeywords: '',
      statePopup: false, // 状态
      stateData: [
        {id: 1, label: '闲置'},
        {id: 2, label: '领用'},
        {id: 3, label: '借出'},
        {id: 4, label: '转租'},
        {id: 5, label: '维修'}
      ],
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    }
  },
  computed: {
    ...mapState(['villageId', 'memberId'])
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // beforeRouteEnter不能通过this访问组件实例，但是可以通过 vm 访问组件实例
      vm.before_page_name = from.name
    })
  },
  created () {
    // 解决安卓软键盘弹出布局问题
    let bodyHeight = document.documentElement.clientHeight + 'px'
    window.addEventListener('resize', () => {
      document.body.style.height = bodyHeight
    })

    this.stocktaking_id = this.$route.query.stocktaking_id
    this.show_stocktake_btn = this.$route.query.show_stocktake_btn
    this.detail = JSON.parse(this.$route.query.detail)
    this.getAreaTree()
    this.getUserTree()
  },
  methods: {
    getAreaTree () {
      this.axios.post('/wechat/basic_info/getAreaTree', {
        member_id: this.memberId,
        village_id: this.villageId
      }).then((res) => {
        if (res.data.status === 1) {
          this.areaData = res.data.data
        }
      })
    },
    getUserTree () {
      this.axios.post('/wechat/basic_info/getVillageMemberTree', {
        member_id: this.memberId,
        village_id: this.villageId
      }).then((res) => {
        if (res.data.status === 1) {
          this.allUserData = res.data.data
          this.userData = res.data.data
        }
      })
    },
    findUser () {
      this.userData = []
      var keywords = this.userKeywords
      let that = this
      this.allUserData.forEach(function (detail) {
        if (detail.label.indexOf(keywords) !== -1) {
          that.userData.push(detail)
        }
      })
    },
    // 保存
    save (stocktakeStatus) {
      var commitDetail = {}
      commitDetail.stocktake_status = stocktakeStatus
      if (this.detail.stocktaking_goods_id) { // 资产在盘点明细中
        commitDetail.stocktaking_goods_id = this.detail.stocktaking_goods_id
      } else { // 追加盘点资产
        commitDetail.asset_id = this.detail.asset_id
      }
      // 撤销盘点
      if (stocktakeStatus === 0) {
        if (!this.detail.stocktaking_goods_id) { // 当前正在追加盘点资产，没有盘点数据可撤销，直接返回列表页即可
          if (this.before_page_name === 'AssetStocktakingEnterCode') {
            this.$router.go(-2)
          } else {
            this.$router.go(-1)
          }
          return false
        }
      }
      // 盘亏
      if (stocktakeStatus === 3) {
        commitDetail.remark = this.detail.remark
        if (this.detail.stocktake_status === 0) { // 如果之前盘点状态是未盘
          if (this.detail.new_area_id || this.detail.new_keeper_member_id || this.detail.new_status) {
            this.$messagebox({
              message: '盘亏只可输入盘点备注',
              closeOnClickModal: false,
              showCancelButton: false,
              confirmButtonText: '好的'
            }).then(action => {
              if (action === 'confirm') {
                this.detail.new_area_id = 0
                this.detail.new_area_name = ''
                this.detail.new_keeper_member_id = 0
                this.detail.new_keeper_member_name = ''
                this.detail.new_status = 0
                this.detail.new_status_info = ''
              }
            })
            return false
          }
        }
      }
      // 盘平、盘盈保存
      if (stocktakeStatus === 1 || stocktakeStatus === 2) {
        commitDetail.remark = this.detail.remark
        if (this.detail.stocktake_status === 0) { // 如果之前盘点状态是未盘，只传修改的盘点信息（因为未盘状态下页面默认所有新数据初始都为空，保存时空数据表示新数据与旧数据相同；已盘状态下新数据默认显示资产当前信息，保存时空数据即是空数据）
          if (this.detail.new_area_id) {
            commitDetail.new_area_id = this.detail.new_area_id
          }
          if (this.detail.new_keeper_member_id) {
            commitDetail.new_keeper_member_id = this.detail.new_keeper_member_id
          }
          if (this.detail.new_status) {
            commitDetail.new_status = this.detail.new_status
          }
        } else {
          commitDetail.new_area_id = this.detail.new_area_id
          commitDetail.new_keeper_member_id = this.detail.new_keeper_member_id
          commitDetail.new_status = this.detail.new_status
        }
      }

      this.axios.post('/wechat/stocktaking/editAssetStocktaking', {
        member_id: this.memberId,
        village_id: this.villageId,
        stocktaking_id: this.stocktaking_id,
        goods: JSON.stringify([commitDetail])
      }).then((res) => {
        if (res.data.status === 1) {
          this.$toast({
            message: '保存成功',
            duration: 5000
          })
          if (this.before_page_name === 'AssetStocktakingEnterCode') {
            this.$router.go(-2)
          } else {
            this.$router.go(-1)
          }
        } else {
          this.$toast({
            message: res.data.info,
            duration: 5000
          })
        }
      }).catch(() => {
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    },

    // 删除盘盈
    del () {
      this.$messagebox({
        message: '确定删除盘盈',
        closeOnClickModal: false,
        showCancelButton: true,
        confirmButtonText: '确定'
      }).then(action => {
        if (action === 'confirm') { // 确认的回调
          this.axios.post('/wechat/stocktaking/editAssetStocktaking', {
            member_id: this.memberId,
            village_id: this.villageId,
            stocktaking_id: this.stocktaking_id,
            goods: JSON.stringify([{stocktaking_goods_id: this.detail.stocktaking_goods_id, stocktake_status: -1}])
          }).then((res) => {
            if (res.data.status === 1) {
              this.$toast({
                message: '删除成功',
                duration: 5000
              })
              if (this.before_page_name === 'AssetStocktakingEnterCode') {
                this.$router.go(-2)
              } else {
                this.$router.go(-1)
              }
            } else {
              this.$toast({
                message: res.data.info,
                duration: 5000
              })
            }
          }).catch(() => {
            this.$toast({
              message: '网络错误',
              duration: 5000
            })
          })
        }
      })
    },
    // 点击使用人
    userClick () {
      this.userPopup = true
    },
    // 关闭使用人弹出
    userClose () {
      this.userPopup = false
    },
    // 点击状态
    stateClick () {
      this.statePopup = true
    },
    // 关闭状态弹出
    stateClose () {
      this.statePopup = false
    },
    // 点击存放位置
    areaClick () {
      this.areaPopup = true
    },
    // 关闭存放位置弹出
    areaClose () {
      this.areaPopup = false
    },
    // 点击空白地方关闭
    clickBlank () {
      this.userPopup = false
      this.statePopup = false
      this.areaPopup = false
    },
    selectStatus (data) {
      this.detail.new_status = data.id
      this.detail.new_status_info = data.label
      this.clickBlank()
    },
    selectArea (data) {
      this.detail.new_area_id = data.id
      this.detail.new_area_name = data.label
      this.clickBlank()
    },
    selectKeeper (data) {
      this.detail.new_keeper_member_id = data.id
      this.detail.new_keeper_member_name = data.label.split('-')[0]
      this.clickBlank()
    }
  }
}
</script>
<style scoped>
.backdrop {
  background-color: #f6f6f6;
  overflow: hidden;
}
.backdrop-top {
  height: calc(100% - 50px);
  overflow-y: auto;
}
.footer-wrapper {
  width: 100%;
  height: 50px;
  font-size: 16px;
  display: flex;
}
.footer-wrapper button {
  flex: 1;
  margin: 0;
  font-size: 14px;
}
.footer-wrapper .delete-btn {
  background-color: #ffffff;
  border: none;
  border-top: 1px solid #d9d9d9;
}
.footer-wrapper .preserve-btn {
  background-color: #7090fd;
  border: none;
  border-top: 1px solid #7090fd;
  color: #ffffff;
}
.list-wrapper .list-detail {
  background-color: #ffffff;
  padding: 10px;
}
.list-wrapper .list-detail .detail-box {
  background-color: #f6f6f6;
  padding: 10px;
}
.list-wrapper .list-detail .detail-box .title {
  font-weight: 600;
  font-size: 16px;
}
.list-wrapper .list-detail .detail-box .describe {
  font-size: 14px;
  margin-top: 10px;
}
.list-wrapper .list-detail .detail-box .describe label {
  display: inline-block;
  width: 80px;
  color: #666;
}
.list-wrapper .row-item {
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin: 0 15px; */
  padding: 10px 15px;
  border-bottom: 1px solid #f6f6f6;
  font-size: 15px;
  background-color: #ffffff;
}
.list-wrapper .row-item input {
  flex: 1;
  width: 100%;
  border: none;
  outline: none;
  font-size: 15px;
  text-align: right;
  padding: 0;
}
.list-wrapper .row-item img {
  width: 12px;
  height: 12px;
  vertical-align: top;
  padding-left: 5px;
}
.select-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 1;
}
.select-mask .select-mask-blank {
  width: 100%;
  height: 100%;
}
.select-mask .select-mask-inner {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #ffffff;
  font-size: 15px;
  height: 300px;
  overflow-y: auto;
}
.select-mask .select-mask-inner .select-mask-content {
  padding: 0 15px;
}
.select-mask .select-mask-inner .head-mask {
  text-align: center;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #f6f6f6;
  position: relative;
}
.select-mask .select-mask-inner .head-mask .close-mask {
  width: 18px;
  height: 18px;
  position: absolute;
  top: 12px;
  right: 10px;
}
.select-mask .select-mask-inner .select-mask-content .level {
  border-bottom: 1px solid #f6f6f6;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  position: relative;
}
.select-mask .select-mask-inner .select-mask-content label {
  display: block;
  border-bottom: 1px solid #f6f6f6;
  padding: 5px 15px;
}
>>>
.mint-switch-core {
  width: 42px;
  height: 22px;
}
>>>
.mint-switch-core::before {
  width: 40px;
  height: 20px;
}
>>>
.mint-switch-core::after {
  width: 20px;
  height: 20px;
}
>>>
.el-tree-node__expand-icon {
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/Material/AssetStocktaking/AssetStocktakingDetail.vue